var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * CZNA-456 — rename a form-config template.
 *
 * <b>A rename does not touch the key.</b> Plan R4: `templateId` is immutable
 * once created, because changing it would mean DELETE + INSERT and the row's
 * `module_setting_history` would be orphaned. What a rename changes is
 * `templateLabel` — which lives INSIDE the JSONB value (plan R2, ADR-0005 §D2
 * keeps the table structure-free), so the operation is an ordinary
 * `PUT /{key}` with one key of the payload rewritten.
 *
 * <b>Why it re-reads inside the mutation instead of using cached state.</b>
 * The PUT needs the whole value plus a current `optimisticLock`. Reading those
 * from a cached hook would let the rename write back a stale body — anything
 * saved from another tab since the cache was filled would be silently reverted
 * by a rename. Fetching immediately before the write keeps the round trip
 * honest, and if someone did save in between, the server's own optimistic lock
 * still rejects rather than clobbers.
 *
 * Note this deliberately writes the SERVER's current value, not the editor's
 * in-memory one: renaming must not commit unsaved layout edits the user has
 * not chosen to save. It does bump `optimisticLock`, so an editor holding
 * unsaved edits will get the existing 409 "changed outside this editor" banner
 * on its next save — the correct, already-handled outcome.
 *
 * MEMORY rule: `useOkapiKy()` is captured in the mutation closure, never
 * listed in a hook dep array.
 */
import { useOkapiKy } from '@folio/stripes/core';
import { useMutation, useQueryClient } from 'react-query';
import { CZNA_MODULE_SETTING_DETAIL } from '../types/apiPaths';
import { formConfigTemplatesQueryKey } from './useFormConfigTemplates';
import { moduleSettingInvalidationKeys } from './useModuleSetting';
import { isTimeoutError } from '../utils/errorKind';
export var RENAME_ERROR_CODE = 'RENAME_ERROR';
var RenameError = /** @class */ (function (_super) {
    __extends(RenameError, _super);
    function RenameError(status, body, cause, timedOut, readTimedOut) {
        if (timedOut === void 0) { timedOut = false; }
        if (readTimedOut === void 0) { readTimedOut = false; }
        var _this = _super.call(this, "useRenameFormConfigTemplate failed: HTTP ".concat(status !== null && status !== void 0 ? status : 'unknown')) || this;
        /** Brand. Not the prototype chain — see {@link isRenameError}. */
        _this.code = RENAME_ERROR_CODE;
        _this.name = 'RenameError';
        _this.status = status;
        _this.timedOut = timedOut;
        _this.readTimedOut = readTimedOut;
        _this.body = body;
        if (cause !== undefined) {
            _this.cause = cause;
        }
        return _this;
    }
    return RenameError;
}(Error));
export { RenameError };
/**
 * Type guard for the catch clause below. **Brand check, deliberately not `instanceof`**
 * — CZNA-686, the same defect shape as CZNA-580's `isBlockingRefsError`.
 *
 * <p>`.ts` files are compiled by ts-loader against `stripes-webpack`'s own tsconfig,
 * which sets no `target`, so the ES5 default applies and `class X extends Error` becomes
 * `Error.call(this, msg) || this` — an object whose prototype is `Error.prototype`, never
 * `RenameError.prototype`. `instanceof RenameError` is therefore **false in the deployed
 * bundle** and **true under jest**, the worst combination a guard can have. The mechanism
 * is written out once, with the bundle evidence, in
 * `src/customErrorInstanceofGate.test.ts`; that test also fails on any new occurrence.
 *
 * <p>What it cost here: the hook's own `throw new RenameError(400, null)` — raised when
 * the stored value is not a JSON object — is the ONE error it produces inside the try
 * block, and the catch re-threw it only when `instanceof` said so. In the bundle it never
 * did, so the 400 was re-wrapped from `err.response?.status`, which such an error has none
 * of, and the dialog got `errorStatus: null` — no message at all where it should have
 * shown the "template body is not an object" one.
 */
export var isRenameError = function (err) { return (typeof err === 'object'
    && err !== null
    && err.code === RENAME_ERROR_CODE
    && 'status' in err); };
var useRenameFormConfigTemplate = function (key, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (options === void 0) { options = {}; }
    // Closure-capture only. MEMORY: ky is unstable — never in deps.
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var recordType = options.recordType, onSuccess = options.onSuccess;
    var mutation = useMutation(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var writing, current, nextValue, err_1, status_1, body, _c;
        var _d;
        var templateLabel = _b.templateLabel;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    writing = false;
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 4, , 9]);
                    return [4 /*yield*/, ky
                            .get(CZNA_MODULE_SETTING_DETAIL(key))
                            .json()];
                case 2:
                    current = _e.sent();
                    // The value is a JSON object (a FormConfig); merging one key is safe.
                    // A non-object body would be a contract breach, not something to
                    // paper over with a spread that would produce `{0: '…'}`.
                    if (current.value === null || typeof current.value !== 'object' || Array.isArray(current.value)) {
                        throw new RenameError(400, null);
                    }
                    nextValue = __assign(__assign({}, current.value), { templateLabel: templateLabel });
                    writing = true;
                    return [4 /*yield*/, ky
                            .put(CZNA_MODULE_SETTING_DETAIL(key), {
                            json: { value: nextValue, optimisticLock: current.optimisticLock },
                        })
                            .json()];
                case 3: return [2 /*return*/, _e.sent()];
                case 4:
                    err_1 = _e.sent();
                    // Brand check, never `instanceof` — see `isRenameError` (CZNA-686).
                    if (isRenameError(err_1))
                        throw err_1;
                    status_1 = (_d = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _d === void 0 ? void 0 : _d.status;
                    body = null;
                    if (!(status_1 === 400 && err_1 && typeof err_1 === 'object' && 'response' in err_1)) return [3 /*break*/, 8];
                    _e.label = 5;
                case 5:
                    _e.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, err_1.response
                            .clone()
                            .json()];
                case 6:
                    body = (_e.sent());
                    return [3 /*break*/, 8];
                case 7:
                    _c = _e.sent();
                    body = null;
                    return [3 /*break*/, 8];
                case 8: throw new RenameError(status_1, body, err_1, writing && isTimeoutError(err_1), !writing && isTimeoutError(err_1));
                case 9: return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            if (recordType) {
                queryClient.invalidateQueries(formConfigTemplatesQueryKey(recordType));
            }
            queryClient.invalidateQueries(formConfigTemplatesQueryKey());
            moduleSettingInvalidationKeys(key)
                .forEach(function (queryKey) { return queryClient.invalidateQueries(queryKey); });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        },
    });
    return {
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isLoading: mutation.isLoading,
        isError: mutation.isError,
        errorStatus: (_b = (_a = mutation.error) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : null,
        timedOut: (_d = (_c = mutation.error) === null || _c === void 0 ? void 0 : _c.timedOut) !== null && _d !== void 0 ? _d : false,
        readTimedOut: (_f = (_e = mutation.error) === null || _e === void 0 ? void 0 : _e.readTimedOut) !== null && _f !== void 0 ? _f : false,
        errorBody: (_h = (_g = mutation.error) === null || _g === void 0 ? void 0 : _g.body) !== null && _h !== void 0 ? _h : null,
        reset: mutation.reset,
    };
};
export default useRenameFormConfigTemplate;
